import { Form, message, Button, Modal, Input, Card, Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import SelectAjax from "../ui/SelectAjax";
import moment from "moment";
import certificationService from "../../services/certification.service";
import { useQuery } from "react-query";
import { useParams, useNavigate, Link } from "react-router-dom";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import apiClient from "../../services/api";
// import PlateFetcher from "../ui/PlateFetcher";
import CustomerForm from "../Admin/Customers/CustomerForm";
import CardInfo from "./CardInfo";
import { PageHeader } from "@ant-design/pro-components";
import Search from "antd/lib/input/Search";

const CertificationCreate = ({ mode = "create", back }) => {
  const [form] = Form.useForm();
  let { id } = useParams();
  const navigate = useNavigate();
  const [plateLoading, setPlateLoading] = useState(false);
  const [duaLoading, setDuaLoading] = useState(false);
  const [customerIsVisible, setCustomerIsVisible] = useState(false);
  const [customerUrl, setCustomerUrl] = useState("customers-list");
  const [sunarpLoading, setSunarpLoading] = useState(false);
  const [certTypeDisabled, setCertTypeDisabled] = useState(false);
  const [permissionMessageShown, setPermissionMessageShown] = useState(false);

  const onClickAddCustomer = () => {
    setCustomerIsVisible(true);
  };

  const changeWeight = (e) => {
    const gross = Number(form.getFieldValue("gross_weight"));
    const dry = Number(form.getFieldValue("dry_weight"));
    form.setFieldsValue({ payload: gross - dry });
  };

  const searchDUA1 = async (dua) => {
    dua = (dua || "").trim();
    if (!dua) return message.warning("Ingresa un número de DUA");

    setDuaLoading(true);
    try {
      // Tu backend: GET /api/consultar-dua/{dua}  (o /api/dua/{dua} si hiciste alias)
      const { data: v } = await apiClient.get(`/consultar-dua/${dua}`);

      // Helpers
      const tonToKg = (x) =>
        x != null && x !== ""
          ? Math.round(parseFloat(String(x).replace(",", ".")) * 1000)
          : "";

      const norm = (x) => (x == null ? "" : x);

      const power = (p) => (p == null ? "" : String(p).replace(",", ".")); // "80,00@6000" -> "80.00@6000"

      form.setFieldsValue({
        // Identificación
        brand: norm(v.marca),
        model: norm(v.modelo),
        motor: norm(v.motor),
        chassis: norm(v.numero_serie) || norm(v.vin),

        // Especificaciones
        color: norm(v.color),
        bodywork: norm(v.carroceria),
        fuel: norm(v.combustible),
        version: norm(v.version),
        class: norm(v.categoria),

        // Años
        year_fabric: norm(v.anio_modelo), // si necesitas otro campo, duplica
        year_model: norm(v.anio_modelo),

        // Dimensiones (m)
        longitude: norm(v.longitud_m),
        height: norm(v.alto_m),
        width: norm(v.ancho_m),

        // Capacidades
        axes_number: norm(v.ejes),
        wheels_number: norm(v.ruedas),
        seats_number: norm(v.asientos),
        passenger_number: norm(v.pasajeros),
        cylinder_number: norm(v.cilindros),

        // Motor
        engine_size: norm(v.cilindrada_litros), // en litros; si quieres cc: Math.round(v*1000)
        power: power(v.potencia),

        // Pesos (t -> kg)
        gross_weight: tonToKg(v.peso_bruto_t),
        dry_weight: tonToKg(v.peso_neto_t),
        payload: tonToKg(v.carga_util_t),

        // Serie/VIN redundante si lo usas en otro campo
        serie: norm(v.numero_serie) || norm(v.vin),
      });

      message.success("Información del DUA cargada");
    } catch (e) {
      message.error(
        e?.response
          ? `Error: ${e.response.status}`
          : "No se pudo consultar el DUA",
      );
    } finally {
      setDuaLoading(false);
    }
  };

  const searchPlateMtc = async (e) => {
    const plate = e;

    if (plate.length === 6) {
      setPlateLoading(true);

      try {
        const response = await apiClient.get("/mtc-search", {
          params: { plate },
        });

        console.log("Respuesta completa:", response.data);

        if (response.data.exito) {
          const data = response.data.datos;

          console.log("Datos del vehículo:", data);
          form.setFieldsValue({
            class: data.categoria || "",
            brand: data.marca || "",
            model: data.modelo || "",
            motor: data.numero_motor || "",
            chassis: data.vin_serie_chasis || "",
            serie: data.vin_serie_chasis || "",
            color: data.color || "",
            bodywork: data.carroceria || "",
            fuel: data.combustible || "",
            year_fabric: data.AñoFab || "",
            axes_number: data.numero_ejes || "",
            wheels_number: data.numero_ruedas || "",
            seats_number: data.numero_asientos || "",
            engine_size: "",
            longitude: data.largo || "",
            height: data.alto || "",
            width: data.ancho || "",
            passenger_number: data.numero_pasajeros || "",
            cylinder_number: "",

            gross_weight: data.peso_bruto ? Number(data.peso_bruto) * 1000 : "",
            dry_weight: data.peso_neto ? Number(data.peso_neto) * 1000 : "",
            payload: data.peso_util ? Number(data.peso_util) * 1000 : "",
          });

          message.success("Información de placa cargada correctamente");
        } else {
          message.warning(
            response.data.mensaje || "No se encontraron datos para esta placa",
          );
        }
      } catch (error) {
        console.error("Error al buscar la placa:", error);
        message.error("Error al obtener información de la placa");
      } finally {
        setPlateLoading(false);
      }
    } else {
      message.info("La placa debe tener 6 caracteres");
    }
  };

  const searchSunarpPlate = async (plate) => {
    if (sunarpLoading) return;
    if (!plate || plate.length !== 6) {
      message.warning("La placa debe tener 6 caracteres");
      return;
    }

    setSunarpLoading(true);

    try {
      const response = await apiClient.get("/sunarp/consulta", {
        params: { placa: plate },
      });

      const payload = response?.data;
      const fuente = payload?.fuente; // url0 | url1 | url2
      const raw = payload?.data;

      let vehicleData = null;
      let ownerData = null;

      if (fuente === "url0" || raw?.data?.Marca) {
        vehicleData = raw?.data ?? null;
        ownerData = { propietario: vehicleData?.Titular ?? "" };
      } else if (fuente === "url2" || raw?.listaAni) {
        vehicleData = raw?.listaAni?.[0] ?? null;
        ownerData =
          vehicleData?.listProp?.[0] ?? vehicleData?.LPropietario?.[0] ?? null;
      } else {
        const root = raw;
        const dataPlaca = root?.data?.data_placa ?? root?.data_placa ?? null;
        const dataSunarp = dataPlaca?.dataSunarp ?? dataPlaca ?? null;

        vehicleData = dataSunarp;
        ownerData =
          vehicleData?.listProp?.[0] ?? vehicleData?.LPropietario?.[0] ?? null;
      }

      if (!vehicleData) {
        message.warning("El servidor no encuentra datos del vehículo.");
        return;
      }

      const grossWeight =
        vehicleData?.PesoBruto ?? vehicleData?.pesoBruto ?? "";
      const dryWeight = vehicleData?.PesoNeto ?? vehicleData?.pesoSeco ?? "";
      const payloadWeight = vehicleData?.CargaUtil ?? "";

      const categoriaClase =
        vehicleData?.coCateg ?? // (ngrok / sunarp)
        vehicleData?.Categoria ?? // (url0)
        vehicleData?.Clase ?? // (url0)
        vehicleData?.categoria ?? // por si acaso
        "";
      form.setFieldsValue({
        owner1: ownerData?.propietario ?? ownerData?.NombrePropietario ?? "",

        brand: vehicleData.marca || vehicleData.Marca || "",
        model: vehicleData.modelo || vehicleData.Modelo || "",
        version: vehicleData.version || vehicleData.Version || "",

        class: categoriaClase,

        motor: vehicleData.numMotor || vehicleData.Motor || "",
        chassis:
          vehicleData.numSerie || vehicleData.Serie || vehicleData.noVin || "",
        serie:
          vehicleData.numSerie || vehicleData.Serie || vehicleData.noVin || "",

        color: vehicleData.color || vehicleData.Colores || "",
        bodywork: vehicleData.descTipoCarr || vehicleData.Carroceria || "",
        fuel: vehicleData.descTipoComb || vehicleData.Combustible || "",

        year_fabric:
          vehicleData.anoFab ?? vehicleData.AñoFabr ?? vehicleData.anMode ?? "",
        year_model: vehicleData.anMode ?? vehicleData.AñoMod ?? "",

        axes_number: vehicleData.ejes ?? vehicleData.Ejes ?? "",
        wheels_number: vehicleData.numRuedas ?? vehicleData.Ruedas ?? "",
        seats_number: vehicleData.numAsientos ?? vehicleData.Asientos ?? "",
        passenger_number:
          vehicleData.numPasajeros ?? vehicleData.Pasajeros ?? "",
        cylinder_number:
          vehicleData.numCilindros ?? vehicleData.Cilindros ?? "",
        power: vehicleData.poMotr ?? vehicleData.Potencia ?? "",
        engine_size: vehicleData.cilindrada ?? vehicleData.Cilindrada ?? "",

        longitude: vehicleData.longitud ?? vehicleData.Longitud ?? "",
        height: vehicleData.altura ?? vehicleData.Altura ?? "",
        width: vehicleData.ancho ?? vehicleData.Ancho ?? "",

        gross_weight: grossWeight,
        dry_weight: dryWeight,
        payload: payloadWeight,
      });

      message.success(
        `Datos del vehículo cargados (${fuente || "desconocido"})`,
      );
    } catch (err) {
      console.error("Error SUNARP:", err);
      message.error("Error al consultar SUNARP");
    } finally {
      setSunarpLoading(false);
    }
  };

  const { data, isFetching } = useQuery(
    ["certifications", id],
    () => certificationService.find(id),
    { keepPreviousData: false, enabled: id > 0 },
  );

  useEffect(() => {
    if (data) {
      form.setFieldsValue(data);
    }
  }, [data]);

  useEffect(() => {
    if (mode !== "create") return;
    if (certTypeDisabled && !permissionMessageShown) {
      message.error("No tienes permiso para crear este tipo de certificado.");
      setPermissionMessageShown(true);
    }
  }, [certTypeDisabled, permissionMessageShown, mode]);

  const finish = async (e) => {
    try {
      if (mode === "create" && certTypeDisabled) {
        message.error("No tienes permiso para crear este tipo de certificado.");
        return;
      }

      let res;
      if (mode === "create") {
        res = await certificationService.create(e);
      } else {
        res = await certificationService.update(id, e);
      }

      if (res.success) {
        message.success(res.message);
        if (mode === "create") {
          navigate("/certifications/" + res.data.id + "/edit");
          return;
        }

        form.setFieldsValue(res.data);

        return;
      }

      message.error(res.message);
    } catch (error) {
      message.error(error.message);
    }
  };

  const removeModel = async () => {
    Modal.confirm({
      title: "Confirmar borrado",
      icon: <ExclamationCircleOutlined />,
      content: "Se borrará este registro y los registros relacionados.",
      okText: "SI",
      cancelText: "NO",
      onOk: async () => {
        const res = await certificationService.remove(id);

        if (!res.success) {
          message.error(res.message ?? "Error al eliminar registro");
        }
        message.success(res.message ?? "Borrado exitoso");
        navigate("/certifications");
      },
    });
  };

  return (
    <div>
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title={mode === "create" ? "Nuevo ingreso" : data?.certification?.name}
        subTitle={data?.date ? moment(data?.date).format("LLL") : ""}
        extra={[
          mode === "edit" && (
            <Button onClick={removeModel} danger key="cancel">
              Anular
            </Button>
          ),
          mode === "edit" && (
            <Button key="modifications">
              <Link to={"/certifications/resolve/" + id}>Modificaciones</Link>
            </Button>
          ),
          <Button
            key="save"
            type="primary"
            onClick={() => form.submit()}
            disabled={mode === "create" && certTypeDisabled}
          >
            Guardar
          </Button>,
        ]}
      />

      <Form
        size="small"
        form={form}
        name="control-hooks"
        disabled={mode === "create" && certTypeDisabled}
        initialValues={{
          certification_type_id: 1,
          //place: "B3G019",
          transport_type_id: 1,
        }}
        onFinish={finish}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 14 }}
      >
        <Card
          loading={isFetching}
          className="cardex"
          title={
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>Datos básicos</div>{" "}
              {mode === "edit" && (
                <div style={{ fontWeight: 300 }}>
                  Operación: {data?.operation_code}
                </div>
              )}
            </div>
          }
        >
          <Form.Item
            labelCol={{ span: 2 }}
            name="certification_type_id"
            label="Tipo cert."
            rules={[{ required: true }]}
          >
            <SelectAjax
              size="middle"
              style={{ maxWidth: 400 }}
              url={"/certification-types?category_id=1"}
              onDisabledChange={setCertTypeDisabled}
            />
          </Form.Item>
          <Form.Item
            labelCol={{ span: 2 }}
            name="company_id"
            label="Empresa"
            rules={[{ required: true }]}
          >
            <SelectAjax
              size="middle"
              showSearch
              optionFilterProp="children"
              url={"/companies-list"}
              style={{ width: 250 }}
            />
          </Form.Item>
          <Form.Item
            labelCol={{ span: 2 }}
            name="customer_id"
            label="Cliente"
            rules={[{ required: true }]}
          >
            <SelectAjax
              onNew={onClickAddCustomer}
              size="middle"
              showSearch
              valueProp="id"
              optionFilterProp="children"
              style={{ marginRight: 5 }}
              url={customerUrl}
            />
          </Form.Item>
          <CustomerForm
            title={"Registrar nuevo cliente"}
            method={"POST"}
            onSuccess={(customer) => {
              setCustomerUrl((url) => url + "?nc=" + Math.random() * 100);
              form.setFieldsValue({ customer_id: customer.id });
              setCustomerIsVisible(false);
            }}
            onCancel={() => {
              setCustomerIsVisible(false);
            }}
            visible={customerIsVisible}
          />

          <Row gutter={4} align="bottom">
            <Col span={7}>
              <Form.Item
                labelCol={{ span: 7 }}
                name="plate"
                label="Placa"
                rules={[
                  {
                    message: "Ingresa placa válida",
                    required: true,
                    pattern: /^(en\s*tramite|[0-9a-zA-Z\-]{6,50})$/i,
                  },
                ]}
              >
                <Search
                  loading={plateLoading}
                  onSearch={searchPlateMtc}
                  placeholder="B3G019"
                  style={{ width: 200 }}
                />
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item>
                <Button
                  type="primary"
                  size="middle"
                  loading={sunarpLoading}
                  disabled={sunarpLoading}
                  onClick={() => {
                    const plateValue = form.getFieldValue("plate");
                    if (plateValue && plateValue.length === 6) {
                      searchSunarpPlate(plateValue);
                    } else {
                      message.warning(
                        "Ingresa una placa válida de 6 caracteres",
                      );
                    }
                  }}
                >
                  SUNARP
                </Button>
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            //initialValue={"118-2021-10-012468-1"}
            labelCol={{ span: 2 }}
            name="dua"
            label="DUA"
            rules={[{ message: "Ingresa dua válida", required: false }]}
          >
            <Search
              loading={duaLoading}
              onSearch={searchDUA1}
              placeholder="Ingresa DUA"
              style={{ width: 250 }}
            />
          </Form.Item>
          <Form.Item
            labelCol={{ span: 2 }}
            name="transport_type_id"
            label="Transporte"
            rules={[{ required: true }]}
          >
            <SelectAjax
              size="middle"
              url={"/transport-types"}
              style={{ width: 250 }}
            />
          </Form.Item>
        </Card>

        <Card
          loading={isFetching}
          className="cardex"
          title="Datos del vehículo"
          style={{ marginTop: 20 }}
        >
          <Form.Item
            name="owner1"
            labelCol={{ span: 2 }}
            label="Propietarios"
            rules={[{ required: false }]}
          >
            <Input size="middle" />
          </Form.Item>

          <Row>
            <Col span={15}>
              <Row>
                <Col span={10}>
                  <Form.Item
                    name="class"
                    label="Cat./Clase"
                    rules={[{ required: false }]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="model"
                    label="Modelo"
                    rules={[{ required: false }]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="brand"
                    label="Marca"
                    rules={[{ required: false }]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="serie"
                    label="VIN"
                    rules={[{ required: false }]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="chassis"
                    label="Serie/Chasis"
                    rules={[{ required: false }]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="motor"
                    label="Motor"
                    rules={[{ required: false }]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="color"
                    label="Color"
                    rules={[{ required: false }]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="bodywork"
                    label="Carrocería"
                    rules={[{ required: false }]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="fuel"
                    label="Combustible"
                    rules={[{ required: false }]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="power"
                    label="Potencia"
                    rules={[{ required: false }]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="version"
                    label="Versión"
                    rules={[{ required: false }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col span={14}>
                  <Row>
                    <Col span={12}>
                      <Form.Item
                        name="year_fabric"
                        label="Año Fabric"
                        rules={[{ required: false }]}
                      >
                        <Input />
                      </Form.Item>

                      <Form.Item
                        name="year_model"
                        label="Año Model"
                        rules={[{ required: false }]}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item
                        name="traction"
                        label="Form. Rod."
                        rules={[{ required: false }]}
                      >
                        <Input />
                      </Form.Item>

                      <Form.Item
                        name="axes_number"
                        label="Ejes"
                        rules={[{ required: false }]}
                      >
                        <Input />
                      </Form.Item>

                      <Form.Item
                        name="wheels_number"
                        label="Ruedas"
                        rules={[{ required: false }]}
                      >
                        <Input />
                      </Form.Item>

                      <Form.Item
                        name="seats_number"
                        label="Asientos"
                        rules={[{ required: false }]}
                      >
                        <Input />
                      </Form.Item>

                      <Form.Item
                        name="engine_size"
                        label="Cilindrada"
                        rules={[{ required: false }]}
                      >
                        <Input />
                      </Form.Item>

                      <Form.Item
                        name="longitude"
                        label="Longitud"
                        rules={[{ required: false }]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>

                    <Col span={12}>
                      <Form.Item
                        name="height"
                        label="Alto"
                        rules={[{ required: false }]}
                      >
                        <Input />
                      </Form.Item>

                      <Form.Item
                        name="width"
                        label="Ancho"
                        rules={[{ required: false }]}
                      >
                        <Input />
                      </Form.Item>

                      <Form.Item
                        name="passenger_number"
                        label="Pasajeros"
                        rules={[{ required: false }]}
                      >
                        <Input />
                      </Form.Item>

                      <Form.Item
                        name="cylinder_number"
                        label="Cilindros"
                        rules={[{ required: false }]}
                      >
                        <Input />
                      </Form.Item>

                      <Form.Item
                        name="gross_weight"
                        label="Peso Bruto"
                        rules={[{ required: false }]}
                      >
                        <Input onChange={changeWeight} />
                      </Form.Item>

                      <Form.Item
                        name="dry_weight"
                        label="Peso seco"
                        rules={[{ required: false }]}
                      >
                        <Input onChange={changeWeight} />
                      </Form.Item>

                      <Form.Item
                        name="payload"
                        label="Carga útil"
                        rules={[{ required: false }]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            {/* <Col span={9}>{mode !== "edit" && <PlateFetcher />}</Col> */}
          </Row>
        </Card>
      </Form>

      <CardInfo certification={data} />
    </div>
  );
};

export default CertificationCreate;
